var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:none;stroke:#fff;}.cls-1{stroke-width:1.2px;}.cls-2,.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-3{stroke-width:1.5px;}.cls-3{opacity:0.4;isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.5.6h0A16.9,16.9,0,0,1,34.4,17.5h0A16.9,16.9,0,0,1,17.5,34.4h0A16.9,16.9,0,0,1,.6,17.5h0A16.9,16.9,0,0,1,17.5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17,17.5a5,5,0,1,0-5-5A5,5,0,0,0,17,17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8,27.5c0-3.87,3.73-7,8.33-7a9.42,9.42,0,0,1,3.09.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27,23.5a3.59,3.59,0,0,1-.12.93,3.73,3.73,0,0,1-.46,1.13A4,4,0,0,1,23,27.5a3.92,3.92,0,0,1-2.66-1,3.68,3.68,0,0,1-.76-.91A3.92,3.92,0,0,1,19,23.5a4,4,0,0,1,4-4,3.94,3.94,0,0,1,3,1.33A4,4,0,0,1,27,23.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23,22.09v2.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.59,23.5h2.82"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEmployee);
export default __webpack_public_path__ + "static/media/Add Employee.c97d25a291d06c3bf61884c86f516738.svg";
export { ForwardRef as ReactComponent };